var map = {
	"./google-laurel-da-DK.svg": 24631,
	"./google-laurel-de-DE.svg": 68837,
	"./google-laurel-en-GB.svg": 11271,
	"./google-laurel-en-US.svg": 50512,
	"./google-laurel-es-ES.svg": 61639,
	"./google-laurel-es-MX.svg": 38580,
	"./google-laurel-fr-FR.svg": 73499,
	"./google-laurel-it-IT.svg": 27533,
	"./google-laurel-nb-NO.svg": 80534,
	"./google-laurel-nl-NL.svg": 29395,
	"./google-laurel-pl-PL.svg": 64087,
	"./google-laurel-pt-BR.svg": 14807,
	"./google-laurel-pt-PT.svg": 64487,
	"./google-laurel-sv-SE.svg": 75318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;